import React from "react";
import PropTypes from "prop-types";

export default function PaginationFooter(
    {
        total = 0,
        page = 1,
        totalPages = 1,
        onPageChange,
        className = "",
        showTotal = true,
        prevLabel = "Назад",
        nextLabel = "Далее",
    }
) {
    const canPrev = page > 1;
    const canNext = page < totalPages;

    const goPrev = () => canPrev && onPageChange?.(page - 1);
    const goNext = () => canNext && onPageChange?.(page + 1);

    return (
        <footer className={`flex items-center justify-between pt-2 ${className}`}>
            {showTotal ? (
                <p className="text-sm text-zinc-500">Найдено: {total}</p>
            ) : (
                <span/>
            )}
            <nav aria-label="Пагинация" className="flex items-center gap-2">
                <button
                    className="btn btn-outline disabled:opacity-50"
                    disabled={!canPrev}
                    onClick={goPrev}
                    aria-label="Предыдущая страница"
                >
                    {prevLabel}
                </button>
                <span className="text-sm" aria-live="polite">
          {page} / {Math.max(1, totalPages)}
        </span>
                <button
                    className="btn btn-outline disabled:opacity-50"
                    disabled={!canNext}
                    onClick={goNext}
                    aria-label="Следующая страница"
                >
                    {nextLabel}
                </button>
            </nav>
        </footer>
    );
}

PaginationFooter.propTypes = {
    total: PropTypes.number,
    page: PropTypes.number,
    totalPages: PropTypes.number,
    onPageChange: PropTypes.func, // обычно setPage
    className: PropTypes.string,
    showTotal: PropTypes.bool,
    prevLabel: PropTypes.string,
    nextLabel: PropTypes.string,
};
